import { gql, graphQueryBang } from "shared/lib/graphql"

const liveAppletDestroyGQL = gql`
  mutation($slug: String!) {
    liveAppletDestroy(input: { applet_id: $slug }) {
      errors {
        attribute
        message
      }
      normalized_applet {
        id
        archived
      }
    }
  }
`

export const deleteLiveAppletMutation = slug =>
  graphQueryBang(liveAppletDestroyGQL, { slug })
